/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Booking_Sync_In_ProgressInputs */

const en_booking_sync_in_progress = /** @type {(inputs: Booking_Sync_In_ProgressInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sent, waiting for the platform`)
};

/**
* | output |
* | --- |
* | "Sent, waiting for the platform" |
*
* @param {Booking_Sync_In_ProgressInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const booking_sync_in_progress = /** @type {((inputs?: Booking_Sync_In_ProgressInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Booking_Sync_In_ProgressInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_booking_sync_in_progress(inputs)
});